export default [
  {
    name: 'institution',
    path: '/institution/index',
    component: () => import('@/views/institution/index'),
    meta: {
      title: '企标制度'
    }
  },
  {
    name: 'institutionReadRecord',
    path: '/institution/readRecord',
    component: () => import('@/views/institution/readRecord'),
    meta: {
      title: '阅读下载记录'
    }
  },
  {
    name: 'externalInstitution',
    path: '/externalInstitution/index',
    component: () => import('@/views/externalInstitution/index'),
    meta: {
      title: '外部制度列表'
    }
  },
  {
    name: 'externalInstitutionReadRecord',
    path: '/externalInstitution/readRecord',
    component: () => import('@/views/externalInstitution/readRecord'),
    meta: {
      title: '阅读记录'
    }
  },
]
